module.exports = __webpack_public_path__ + "static/media/DSC_6232-HDR.2f916bdb.jpg";